export const FILE_EXTENSION_REGEX = /\.[^.]+$/;
